module.exports = __webpack_public_path__ + "static/media/mute.b5df1025.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mute.svg
// module id = 88
// module chunks = 0